import { InputLabel } from "@material-ui/core";
import {
  DivStyled,
  InputBaseStyled,
  StyledInputBase,
} from "./styles/InputBaseDecimalErp";
const InputBaseDecimalErp = ({
  subtitle = "",
  startTag = "",
  decimal = 2,
  value = 0,
  setValue,
  negative = false,
  setNegative = () => {},
  onChange = (e) => {
    setValue(e.target.value);
    setNegative(negative);
  },
  ...props
}) => {
  return (
    <DivStyled>
      <StyledInputBase className={negative ? "negative" : ""}>
        <InputBaseStyled
          value={
            (negative ? "- " : "") +
            startTag.trim() +
            (startTag ? " " : "") +
            value
          }
          inputprops={{ "aria-label": "naked" }}
          onChange={(e) => {
            onChange(e);
          }}
          {...props}
        />
        <InputLabel shrink htmlFor="bootstrap-input">
          {subtitle}
        </InputLabel>
      </StyledInputBase>
    </DivStyled>
  );
};

export default InputBaseDecimalErp;
